import * as actionTypes from "./actionTypes";

export const actions = {
  getSelectedProductSuccess: (payload) => ({
    type: actionTypes.GET_PRODUCT_DETAILS_SUCCESS,
    payload,
  }),
  getSelectedProductRequest: (payload) => ({
    type: actionTypes.GET_PRODUCT_DETAILS_REQUEST,
    payload,
  }),
  updateProductQuantity: (payload) => ({
    type: actionTypes.UPDATE_PRODUCT_QUANTITY,
    payload,
  }),

  selectPaymentMode: (payload) => ({
    type: actionTypes.SELECT_PAYMENT_MODE,
    payload,
  }),
  isSuscribed: (payload) => ({
    type: actionTypes.IS_SUSCRIBED,
    payload,
  }),
  updateUserAddress: (payload) => ({
    type: actionTypes.SET_ADDRESS_OF_USER,
    payload,
  }),
};

const initialState = {
  currentProductDetail: null,
  quantity: 0,
  paymentMode: "COD",
  suscribed: false,
  userAddress: {},
};

function reducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.GET_PRODUCT_DETAILS_SUCCESS:
      return {
        ...state,
        currentProductDetail: action.payload,
        quantity: 1,
      };

    case actionTypes.GET_PRODUCT_DETAILS_REQUEST:
      return {
        ...state,
        currentProductDetail: null,
        quantity: 0,
      };
    case actionTypes.UPDATE_PRODUCT_QUANTITY:
      return {
        ...state,
        quantity: parseInt(state.quantity) + parseInt(action.payload),
      };
    case actionTypes.SELECT_PAYMENT_MODE:
      return {
        ...state,
        paymentMode: action.payload,
      };
    case actionTypes.IS_SUSCRIBED:
      return {
        ...state,
        suscribed: action.payload,
      };
    case actionTypes.SET_ADDRESS_OF_USER:
      return {
        ...state,
        userAddress: action.payload,
      };

    case actionTypes.RESET_SELECTED_PRODUCT_STATE: {
      return initialState;
    }
    default:
      return state;
  }
}
reducer.initialState = initialState;

export default reducer;
